import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function TransformationSection() {
  const before = ['Stundenlanges Planen jeder Stunde', 'Sich wiederholende Stunden', 'Keine philosophische Tiefe', 'Nicht wissen, was man verlangen soll', 'Schülerinnen, die abspringen'];
  const after = ['5 Minuten Wiederholung', 'Abwechslungsreiche Stunden', 'Jede Woche ein philosophisches Thema', 'Klare Preise und Selbstvertrauen', 'Treue Community'];
  const microStats = [{
    value: '+200',
    label: 'STUNDEN'
  }, {
    value: '5',
    label: 'BÄNDE'
  }, {
    value: '100%',
    label: 'HERUNTERLADBAR'
  }];
  return <section className="bg-brand-cream px-4 py-20" data-id="element-165">
      <div className="mx-auto max-w-5xl" data-id="element-166">
        <div className="mb-16 flex flex-col items-center gap-12 md:flex-row" data-id="element-167">
          <div className="flex-1" data-id="element-168">
            <h2 className="mb-6 text-4xl font-black leading-[1.1] tracking-tight text-brand-text md:text-5xl" data-id="element-169">
              Von einer überlasteten Lehrerin zu einer{' '}
              <span className="italic text-brand-green" data-id="element-170">
                inspirierten Anleiterin.
              </span>
            </h2>
            <div className="inline-flex items-center gap-4 rounded-2xl bg-white/70 p-4" data-id="element-171">
              <span className="font-serif text-4xl font-bold text-brand-terracotta" data-id="element-172">
                3.800+
              </span>
              <span className="max-w-[170px] text-sm font-medium leading-tight text-brand-gray" data-id="element-173">
                Stunden pro Jahr bei der Planung gespart.
              </span>
            </div>
          </div>

          <div className="grid w-full flex-1 grid-cols-2 overflow-hidden rounded-3xl border border-brand-creamDark bg-white shadow-sm" data-id="element-174">
            <div className="bg-[#FCF8F2] p-5 md:p-7" data-id="element-175">
              <div className="mb-6 flex items-center gap-2" data-id="element-176">
                <XCircle className="h-6 w-6 shrink-0 text-brand-terracotta" aria-hidden="true" data-id="element-177" />
                <h3 className="text-xs font-bold uppercase tracking-wider text-brand-terracotta md:text-sm" data-id="element-178">
                  Vorher
                </h3>
              </div>
              <ul className="space-y-5" data-id="element-179">
                {before.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-180">
                    <XCircle className="mt-0.5 h-5 w-5 shrink-0 text-brand-terracotta/70" aria-hidden="true" data-id="element-181" />
                    <span className="text-sm font-medium leading-snug text-brand-text md:text-base" data-id="element-182">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="border-l border-brand-creamDark bg-[#F0F5F1] p-5 md:p-7" data-id="element-183">
              <div className="mb-6 flex items-center gap-2" data-id="element-184">
                <CheckCircle2 className="h-6 w-6 shrink-0 text-brand-green" aria-hidden="true" data-id="element-185" />
                <h3 className="text-xs font-bold uppercase tracking-wider text-brand-green md:text-sm" data-id="element-186">
                  Mit Yoga Bereit
                </h3>
              </div>
              <ul className="space-y-5" data-id="element-187">
                {after.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-188">
                    <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" aria-hidden="true" data-id="element-189" />
                    <span className="text-sm font-semibold leading-snug text-brand-text md:text-base" data-id="element-190">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="flex justify-center gap-2 sm:gap-4 md:gap-8" data-id="element-191">
          {microStats.map(stat => <div key={stat.label} className="flex min-w-[90px] flex-col items-center rounded-full border border-brand-creamDark bg-white px-4 py-3 shadow-sm sm:px-6" data-id="element-192">
              <span className="font-serif text-xl font-bold text-brand-text" data-id="element-193">
                {stat.value}
              </span>
              <span className="text-center text-[9px] font-medium tracking-wider text-brand-gray sm:text-[10px]" data-id="element-194">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}